import app from 'flarum/common/app';
import Widgets from 'ext:fof/forum-widgets-core/common/extend/Widgets';
import GroupLegendWidget from './components/GroupLegendWidget';
export default function registerWidget() {
  new Widgets().add({
    key: 'groupLegend',
    component: GroupLegendWidget,
    isDisabled: false,
    isUnique: true,
    placement: 'end',
    position: 2
  }).extend(app, 'swtorpolska-group-legend');
}
flarum.reg.add('swtorpolska-group-legend', 'common/registerWidget', registerWidget);